import { analyticsReporter } from "../AnalyticsReporter";

class Initializer {
    initialize() {
        analyticsReporter.initialize();
    }
}

export const initializer = new Initializer();